import React from 'react';
import styles from '../Dashboards.module.css';
import { contextToName } from '../helpers';

function ReportListEmptyState({
  selectedReportType,
  searchString,
  context,
  emptyStateHeader = null,
  emptyStateBody = null,
}) {
  const emptyStateText = (function (reportType, searchString) {
    if (emptyStateHeader && emptyStateBody) {
      return {
        title: emptyStateHeader,
        body: emptyStateBody,
      };
    }
    if (searchString !== '') {
      return {
        title: 'No results found',
        body: (
          <div>Try rewording your search or entering a new search term.</div>
        ),
      };
    }
    switch (reportType) {
      case 'all':
        return {
          title: 'No views created',
          body: (
            <div>
              <p>
                {contextToName(context, true, true)} can be copied from a saved
                list, pivot, chart, or custom roadmap.
              </p>
              <p>
                Click <b>Save</b> on any of these view to save it or add a{' '}
                {contextToName(context)}
                by creating a brand new {contextToName(context)}
              </p>
            </div>
          ),
        };
      case 'recents':
        return {
          title: 'No recent views',
          body: (
            <div>
              <p>
                {contextToName(context, true, true)} can be copied from a saved
                list, pivot, chart, or custom roadmap.
              </p>
              <p>
                You have not opened any of these views yet. Click <b>All</b> to
                see all available views.
              </p>
            </div>
          ),
        };

      case 'favorites':
        return {
          title: 'No favorite views',
          body: (
            <div>
              <p>
                {contextToName(context, true, true)} can be copied from a saved
                list, pivot, chart, or custom roadmap.
              </p>
              <p>
                You have not favorited any of these views yet. Click <b>All</b>{' '}
                to see all available views.
              </p>
            </div>
          ),
        };
      case 'list':
      case 'roadmap':
      case 'pivot':
      case 'chart':
        return {
          title: 'No views created',
          body: (
            <div>
              You have not created any {reportType} views yet. Click <b>All</b>{' '}
              to see all available views.
            </div>
          ),
        };
      case 'created_by_me':
        return {
          title: 'No views created',
          body: (
            <div>
              <p>
                {context === 'note' ? 'View' : 'Panels'} can be copied from a
                saved list, pivot, chart, or custom roadmap.
              </p>
              <p>
                You have not created any of these views yet. Click <b>Save</b>{' '}
                on any view to save it or add a panel by creating a brand new
                view.
              </p>
            </div>
          ),
        };
      default:
        return reportType.replace(/_/g, ' ');
    }
  })(selectedReportType, searchString);

  return (
    <div className={styles.ReportListEmptyState}>
      <div className={styles.ReportListEmptyStateTitle}>
        {emptyStateText.title}
      </div>
      <br />
      <div>{emptyStateText.body}</div>
    </div>
  );
}

export default ReportListEmptyState;
